function startTimer(duration, display) {
    var timer = duration, minutes, seconds;
    setInterval(function () {
        minutes = parseInt(timer / 60, 10);
        seconds = parseInt(timer % 60, 10);

        minutes = minutes < 10 ? "0" + minutes : minutes;
        seconds = seconds < 10 ? "0" + seconds : seconds;

        display.textContent = minutes + ":" + seconds;
if(timer <= 0){
        document.querySelector('#countdown').textContent = "Promo Code expired!";
        document.querySelector('#countdown').style.display = 'none';
      }  
        if (--timer < 0) {
            timer = duration;
        }
    },1000);
}


  var code = window.localStorage.getItem('code');
    var Minutes = 60 * 10,
        display = document.querySelector('#timer');
    if(display){startTimer(Minutes, display);}
  if(code == 'true'){
    setTimeout(function () {
  document.querySelector('#countdown').style.display = 'block';window.localStorage.clear();
      },1000);
    }


if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      if (document.body.classList.contains('template-cart')) {
      this.form.querySelector('.customatc').addEventListener('click', this.onSubmitHandler.bind(this));
      }      
      
      this.cartNotification = document.querySelector('cart-notification');
    }

    onSubmitHandler(evt) { console.log('discountCode');
      evt.preventDefault();
      const submitButton = this.querySelector('[type="submit"]');
      if (submitButton.classList.contains('loading')) return;

      this.handleErrorMessage();
      this.cartNotification.setActiveElement(document.activeElement);

      submitButton.setAttribute('aria-disabled', true);
      submitButton.classList.add('loading');
      this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData(this.form);
      formData.append('sections', this.cartNotification.getSectionsToRender().map((section) => section.id));
      formData.append('sections_url', window.location.pathname);
      config.body = formData;
 
      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            this.handleErrorMessage(response.description);
            return;
          }
           var sale_form = document.querySelector('.ac_sale_product-form');
      if(sale_form){ 
var COUPON_CODE = "ACCU20";
fetch('/discount/' + COUPON_CODE, {
      method: 'GET'
    })
    .then(response => {  
             console.log('xxx');             
    })
    .catch(error => {      
    });
      }
          this.cartNotification.renderContents(response);
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          submitButton.classList.remove('loading');
          submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading-overlay__spinner').classList.add('hidden');
          if (document.body.classList.contains('template-cart')) {
    window.location.href="/cart";
}
        });
    }

    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}
